import axios from 'axios'
import {envVars} from '@/envVars.ts'
import {attemptRefresh} from '@/axiosInstance.ts'
import {useAuthStore} from '@features/user/store/store.ts'
import {LOCAL_STORAGE_ACCESS_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN} from '@features/user/constants.ts'

const axiosConfig = {
    baseURL: envVars.VITE_API_ENDPOINT_NODE,
    headers: {
        common: {
            Authorization: localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN)
                ? `Bearer ${localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN)}`
                : false,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        post: {
            'Access-Control-Allow-Origin': '*'
        }
    }
}

// create axios custom instance with custom config
const axiosInstanceNode = axios.create(axiosConfig)

axiosInstanceNode.interceptors.request.use(request => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN)
    if (token) request.headers['Authorization'] = `Bearer ${token}`
    return request
})

axiosInstanceNode.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        const statusCode = error?.response?.status
        const originalRequest = error.config

        switch (statusCode) {
            case 401: {
                const refreshToken = useAuthStore.getState().refreshToken
                localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN)
                if (refreshToken && !originalRequest._retry) {
                    originalRequest._retry = true
                    await attemptRefresh(refreshToken)
                    return axiosInstanceNode.request(originalRequest)
                } else {
                    useAuthStore.getState().resetAuthTokens()
                    return Promise.reject(error)
                }
            }
            default:
                return Promise.reject(error)
        }
    }
)

export default axiosInstanceNode
